
export default function InsertionCard(prop){
    return (
        <>
            <div class="col-xl-6 col-sm-6 col-12">
                <div class="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                    <div class="product-img">
                        <a href={"/inserzione/" + prop.info.id}><img src={prop.info.media.medium} alt="#"/></a>
                        
                    </div>
                    <div class="product-info">
                        <div class="product-badge">
                            <ul>
                                <li class="sale-badge">{prop.info.type == 'rent' ? 'Affitto' : 'Vendita'}</li>
                            </ul>
                        </div>
                        <h2 class="product-title"><a href={"/inserzione/" + prop.info.id}>{prop.info.title}</a></h2>
                        
                        <div class="product-img-location">
                            <ul>
                                <li>
                                    <a href={"/inserzione/" + prop.info.id}><i class="flaticon-pin"></i> {prop.info.location.address}, {prop.info.location.city}</a>
                                </li>
                            </ul>
                        </div>
                        <ul class="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                            <li>
                                <span>3</span> Locali
                            </li>
                            <li>
                                <span>2</span> Bagni
                            </li>
                            <li>
                                <span>3450</span> mq
                            </li>
                        </ul>
                                                        
                    </div>
                    <div class="product-info-bottom">
                        <div class="product-price">
                            <span>{prop.info.formatted_price}<label>{prop.info.type == 'rent' ? '/mese' : ''}</label></span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}